import { X, Edit, Trash2, ShieldCheck, Lock } from 'lucide-react';

interface SettingsSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  onEditProfile?: () => void;
  onDeleteProfile?: () => void;
  onPrivacy?: () => void;
  onVerification?: () => void;
}

export function SettingsSidebar({ 
  isOpen, 
  onClose, 
  onEditProfile, 
  onDeleteProfile,
  onPrivacy,
  onVerification
}: SettingsSidebarProps) {
  
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 transition-opacity"
        onClick={onClose}
        style={{ opacity: isOpen ? 1 : 0 }}
      />

      {/* Sidebar */}
      <div
        className="fixed top-0 right-0 h-full w-80 z-50 transition-transform duration-300"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
          background: 'linear-gradient(to bottom, rgba(10, 10, 15, 0.98), rgba(5, 5, 10, 0.98))',
          backdropFilter: 'blur(20px)',
          borderLeft: '1px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '-4px 0 24px rgba(0, 0, 0, 0.5)',
        }}
      >
        {/* Header */}
        <div
          className="flex items-center justify-between p-6 border-b"
          style={{ borderColor: 'rgba(255, 255, 255, 0.1)' }}
        >
          <h2 style={{ color: '#FFFFFF' }}>Налаштування</h2>
          <button
            onClick={onClose}
            className="p-2 rounded-full transition-all hover:bg-white/10"
          >
            <X className="w-6 h-6" style={{ color: 'rgba(255, 255, 255, 0.7)' }} />
          </button>
        </div>

        {/* Content */}
        <div
          className="p-4 space-y-3 overflow-y-auto pb-24"
          style={{ maxHeight: '100vh' }}
        >
          {/* Edit Profile */}
          {onEditProfile && (
            <button
              onClick={() => {
                onEditProfile();
                onClose();
              }}
              className="w-full p-4 rounded-2xl flex items-center gap-3 border backdrop-blur-xl transition-all hover:border-[#00FF88]/50"
              style={{
                background: 'rgba(0, 255, 136, 0.05)',
                borderColor: 'rgba(0, 255, 136, 0.2)',
                boxShadow:
                  '0 4px 16px rgba(0, 255, 136, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.08)',
              }}
            >
              <Edit className="w-5 h-5" style={{ color: '#00FF88' }} />
              <span style={{ color: '#00FF88' }}>Редагувати профіль</span>
            </button>
          )}

          {/* Privacy */}
          {onPrivacy && (
            <button
              onClick={() => {
                onPrivacy();
                onClose();
              }}
              className="w-full p-4 rounded-2xl flex items-center gap-3 border backdrop-blur-xl transition-all hover:border-white/30"
              style={{
                background: 'rgba(255, 255, 255, 0.05)',
                borderColor: 'rgba(255, 255, 255, 0.12)',
              }}
            >
              <Lock className="w-5 h-5" style={{ color: '#FFFFFF' }} />
              <span style={{ color: '#FFFFFF' }}>Приватність</span>
            </button>
          )}

          {/* Verification */}
          {onVerification && (
            <button
              onClick={() => {
                onVerification();
                onClose();
              }}
              className="w-full p-4 rounded-2xl flex items-center gap-3 border backdrop-blur-xl transition-all hover:border-white/30"
              style={{
                background: 'rgba(255, 255, 255, 0.05)',
                borderColor: 'rgba(255, 255, 255, 0.12)',
              }}
            >
              <ShieldCheck className="w-5 h-5" style={{ color: '#FFFFFF' }} />
              <span style={{ color: '#FFFFFF' }}>Верифікація</span>
            </button>
          )}

          {/* Delete Profile */}
          {onDeleteProfile && (
            <button
              onClick={() => {
                onDeleteProfile();
                onClose();
              }}
              className="w-full p-4 rounded-2xl flex items-center gap-3 border backdrop-blur-xl transition-all hover:border-red-500/50"
              style={{
                background: 'rgba(255, 0, 0, 0.05)',
                borderColor: 'rgba(255, 0, 0, 0.2)',
                boxShadow:
                  '0 4px 16px rgba(255, 0, 0, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.08)',
              }}
            >
              <Trash2 className="w-5 h-5" style={{ color: 'rgba(255, 100, 100, 0.9)' }} />
              <span style={{ color: 'rgba(255, 100, 100, 0.9)' }}>Видалити профіль</span>
            </button>
          )}
        </div>
      </div>
    </>
  );
}
